// Single-source product constants — mirrors backend/app/constants.py.
// Challenges 1..(FIRST_NFT_SEQUENCE-1) award show-card memes; challenge
// FIRST_NFT_SEQUENCE onwards awards mintable NFTs (the "pivotal moment").
export const FIRST_NFT_SEQUENCE = 13;
